import { downloadCSV } from "../utils/csvDownload";

interface TotalPerSiteAdminProps {
    data: any[];
    isLoading: boolean;
}

export const TotalPerSiteAdmin = ({
    data,
    isLoading,
}: TotalPerSiteAdminProps) => {
    return (
        <div className="h-full flex items-center justify-center p-8">
            <button
                onClick={() => downloadCSV(data, "total_per_site.csv")}
                disabled={isLoading || !data.length}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
                {isLoading ? "Loading..." : "Download Site Data (CSV)"}
            </button>
        </div>
    );
};
